<template>
	<div id="czjl" v-loading="loading">
		<div class="czjl_main">
			<div class="query_info">
				<!-- 订单状态 -->
				<el-select v-model="currOrderType" placeholder="请选择订单状态">
					<el-option v-for="item in orderType" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
				<!-- 充值方式 -->
				<el-select v-model="currPutInType" placeholder="请选择充值方式">
					<el-option v-for="item in putInType" :key="item.Value" :label="item.Name" :value="item.Value" />
				</el-select>
				<!-- 订单编号 -->
				<el-input v-model="orderNum" placeholder="请输入订单编号"></el-input>
				<div class="input-br" />
				<el-date-picker
					v-model="beginDate"
					type="datetime"
					placeholder="开始日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				/>
				<el-date-picker
					v-model="endDate"
					type="datetime"
					placeholder="结束日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				/>
				<el-button class="el-button--primary" @click="czCxBtn">查询</el-button>
			</div>
			<div class="czTable">
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column prop="OrderNumber" width="150" label="流水号" />
					<el-table-column prop="CreateTime" label="发起时间" width="155" />
					<el-table-column prop="CompleteTime" label="到账时间" width="155" />
					<el-table-column prop="RcMoney" label="充值金额" width="80" />
					<el-table-column prop="UsdtCount" label="币数" width="75" />
					<el-table-column prop="Rate" label="汇率" width="60" />
					<el-table-column prop="PayTypeText" label="充值方式" width="120" />
					<el-table-column prop="StatusText" label="状态" width="66">
						<template slot-scope="scope">
							<span class="unpaidState" v-if="scope.row.StatusText === '未支付'">{{ scope.row.StatusText }}</span>
							<span class="cancelState" v-if="scope.row.StatusText === '已取消'">{{ scope.row.StatusText }}</span>
							<span class="payState" v-if="scope.row.StatusText === '已支付'">{{ scope.row.StatusText }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="Remark" label="备注"></el-table-column>
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.png" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
			<div class="my-paging" v-show="czTableData.length != 0">
				<div class="everyPageShow">每页显示 10 条</div>
				<div class="totalNum">共{{ paginationArray.total }}条</div>
				<el-pagination
					@current-change="handleCurrentChange"
					:page-size="paginationArray.currpageSize"
					layout="prev, pager, next, jumper"
					:total="paginationArray.total"
					background
				/>
			</div>
		</div>
		<!-- 弹窗 -->
		<el-dialog title="提示" :visible.sync="dialogVisible">
			<div class="warning_img">
				<i class="el-icon-warning"></i>
			</div>
			<div style="text-align: center">您的账号已在另一处登录了，您已下线，请重新登录</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			loading: false,
			//显示弹框
			dialogVisible: false,
			// 订单状态
			orderType: [
				{ value: "", label: "请选择" },
				{ value: "0", label: "未支付" },
				{ value: "1", label: "已取消" },
				{ value: "2", label: "已支付" },
			],
			currOrderType: "",
			//充值方式
			putInType: [
				{ Value: "1", Name: "支付成功" },
				{ Value: "2", Name: "支付失败" },
				{ Value: "3", Name: "融付" },
			],
			currPutInType: "",
			//订单编号
			orderNum: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [],
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
		};
	},

	methods: {
		initDate() {
			let etad = new Date();
			let y = etad.getFullYear();
			let m = ("00" + (etad.getMonth() + 1)).slice(-2);
			let d = etad.getDate();
			let h = etad.getHours();
			d = h > 3 ? d : d - 1;
			this.beginDate = `${y}-${m}-${("00" + d).slice(-2)} 03:00:00`;
			this.endDate = `${y}-${m}-${("00" + (d + 1)).slice(-2)} 03:00:00`;
		},
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.czCxBtn();
		},
		//得到支付方式列表
		getPayList() {
			let that = this;
			let url = "api/Sys/GetPayTypeList";

			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.putInType = data.Data;
					that.czCxBtn();
				}
			});
		},
		//查询数据
		czCxBtn() {
			let that = this;
			let url = "api/Cash/RechargeHistoryList";
			let cxData = {
				StartTime: this.beginDate,
				EndTime: this.endDate,
				OrderNumber: this.orderNum,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
				PayType: this.currPutInType,
				Status: this.currOrderType,
			};
			this.loading = true;
			postAjax(url, cxData)
				.then(data => {
					this.loading = false;
					if (data.IsSucess) {
						that.czTableData = data.Data.rows;
						that.paginationArray.total = data.Data.total;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.czCxBtn();
		},
		//时间格式化
		formatDate(row, column) {
			if (row[column.property]) {
				var arr = row[column.property].split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			} else {
				return "-";
			}
		},
	},
	mounted() {
		this.initDate();
		this.getPayList();
	},
};
</script>

<style type="scss">
#czjl {
	height: 100%;
}

.czjl_main {
	padding: 20px 0px 20px 0;
}

.warning_img > .el-icon-warning {
	font-size: 54px;
	color: #1e8edd;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountCenter/czjl.vue